import { compose as o } from "../../tailwind-buddy-interface.js";
import { labelStyles as e } from "../../mixins/typography.js";
const t = o({
  slots: {
    root: `
      inline-flex
      max-w-full
      items-center
      py-025
      ps-050
      pe-050
      rounded-xs
      backdrop-blur-md
    `,
    label: `
      ${e.xs}
      font-weight-bolder
      text-center
      py-025
      ps-050
      pe-050
    `,
    icon: `
      shrink-0
    `
  },
  variants: {
    colorScheme: {
      primary: {},
      neutral: {},
      positive: {},
      informative: {},
      negative: {},
      notice: {},
      special: {}
    },
    variant: {
      solid: {
        root: `
          text-color-primary-inverse
        `,
        icon: `
          text-color-icon-primary-inverse
        `
      },
      subtle: {
        /** TODO: use `-outline-offset-sm` once outline offset tokens are available */
        root: `
          outline
          outline-width-sm
          -outline-offset-1
        `
      }
    }
  },
  compoundVariants: [
    // variant="solid" / colorScheme="primary"
    {
      conditions: {
        variant: "solid",
        colorScheme: "primary"
      },
      class: {
        root: "bg-color-scheme-brand-primary-500 outline-color-scheme-brand-primary-500",
        label: "",
        icon: ""
      }
    },
    // variant="subtle" / colorScheme="primary"
    {
      conditions: {
        variant: "subtle",
        colorScheme: "primary"
      },
      class: {
        root: "bg-color-scheme-brand-primary-100 outline-color-scheme-brand-primary-200",
        label: "text-color-scheme-brand-primary-800",
        icon: "text-color-scheme-brand-primary-400"
      }
    },
    // variant="solid" / colorScheme="neutral"
    {
      conditions: {
        variant: "solid",
        colorScheme: "neutral"
      },
      class: {
        root: "bg-color-scheme-neutral-500 outline-color-scheme-neutral-500",
        label: "",
        icon: ""
      }
    },
    // variant="subtle" / colorScheme="neutral"
    {
      conditions: {
        variant: "subtle",
        colorScheme: "neutral"
      },
      class: {
        root: "bg-color-scheme-neutral-100 outline-color-scheme-neutral-200",
        label: "text-color-scheme-neutral-800",
        icon: "text-color-scheme-neutral-400"
      }
    },
    // variant="solid" / colorScheme="informative"
    {
      conditions: {
        variant: "solid",
        colorScheme: "informative"
      },
      class: {
        root: "bg-color-scheme-functional-informative-500 outline-color-scheme-functional-informative-500",
        label: "",
        icon: ""
      }
    },
    // variant="subtle" / colorScheme="informative"
    {
      conditions: {
        variant: "subtle",
        colorScheme: "informative"
      },
      class: {
        root: "bg-color-scheme-functional-informative-100 outline-color-scheme-functional-informative-200",
        label: "text-color-scheme-functional-informative-800",
        icon: "text-color-scheme-functional-informative-400"
      }
    },
    // variant="solid" / colorScheme="positive"
    {
      conditions: {
        variant: "solid",
        colorScheme: "positive"
      },
      class: {
        root: "bg-color-scheme-functional-positive-500 outline-color-scheme-functional-positive-500",
        label: "",
        icon: ""
      }
    },
    // variant="subtle" / colorScheme="positive"
    {
      conditions: {
        variant: "subtle",
        colorScheme: "positive"
      },
      class: {
        root: "bg-color-scheme-functional-positive-100 outline-color-scheme-functional-positive-200",
        label: "text-color-scheme-functional-positive-800",
        icon: "text-color-scheme-functional-positive-400"
      }
    },
    // variant="solid" / colorScheme="negative"
    {
      conditions: {
        variant: "solid",
        colorScheme: "negative"
      },
      class: {
        root: "bg-color-scheme-functional-negative-500 outline-color-scheme-functional-negative-500",
        label: "",
        icon: ""
      }
    },
    // variant="subtle" / colorScheme="negative"
    {
      conditions: {
        variant: "subtle",
        colorScheme: "negative"
      },
      class: {
        root: "bg-color-scheme-functional-negative-100 outline-color-scheme-functional-negative-200",
        label: "text-color-scheme-functional-negative-800",
        icon: "text-color-scheme-functional-negative-400"
      }
    },
    // variant="solid" / colorScheme="notice"
    {
      conditions: {
        variant: "solid",
        colorScheme: "notice"
      },
      class: {
        root: "bg-color-scheme-functional-notice-500 outline-color-scheme-functional-notice-500",
        label: "",
        icon: ""
      }
    },
    // variant="subtle" / colorScheme="notice"
    {
      conditions: {
        variant: "subtle",
        colorScheme: "notice"
      },
      class: {
        root: "bg-color-scheme-functional-notice-100 outline-color-scheme-functional-notice-200",
        label: "text-color-scheme-functional-notice-800",
        icon: "text-color-scheme-functional-notice-400"
      }
    },
    // variant="solid" / colorScheme="special"
    {
      conditions: {
        variant: "solid",
        colorScheme: "special"
      },
      class: {
        root: "bg-color-scheme-functional-special-500 outline-color-scheme-functional-special-500",
        label: "",
        icon: ""
      }
    },
    // variant="subtle" / colorScheme="special"
    {
      conditions: {
        variant: "subtle",
        colorScheme: "special"
      },
      class: {
        root: "bg-color-scheme-functional-special-100 outline-color-scheme-functional-special-200",
        label: "text-color-scheme-functional-special-800",
        icon: "text-color-scheme-functional-special-400"
      }
    }
  ],
  defaultVariants: {
    colorScheme: "primary",
    variant: "subtle"
  },
  responsiveVariants: []
})();
export {
  t as tagVariants
};
